import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({
    children,
    delay = 0,
    y = 24,
    duration = 0.9,
    className = "",
    as: As = "div",
    once = true,
    ...rest
}) => {
    const MotionTag = motion[As] || motion.div;
    return (
        <MotionTag
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-80px" }}
            transition={{ duration, delay, ease: EASE }}
            className={className}
            {...rest}
        >
            {children}
        </MotionTag>
    );
};

export const RevealStagger = ({ children, className = "", delay = 0 }) => (
    <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
        variants={{
            hidden: {},
            show: {
                transition: { staggerChildren: 0.08, delayChildren: delay },
            },
        }}
        className={className}
    >
        {children}
    </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 24 }) => (
    <motion.div
        variants={{
            hidden: { opacity: 0, y },
            show: {
                opacity: 1,
                y: 0,
                transition: { duration: 0.9, ease: EASE },
            },
        }}
        className={className}
    >
        {children}
    </motion.div>
);
